/* eslint no-unused-expressions: "off" */
import _ from "underscore";

// createFilterSentence
// shortenTextArray
// textTooLong
// unintelligibleTitle

// Returns a grammatically correct description of the currentFiltersList:
//		"shared by 18 - 24 year old females from Alaska"
//		"published by Left-Leaning Government outlets from California with a reach of 100,000+."
export const createFilterSentence = (currentFiltersList, perspective, narrativeData, noNarrativeText) => {
	// console.log("currentFiltersList", currentFiltersList);
	const clonedFilters = JSON.parse(JSON.stringify(currentFiltersList));
	const narrativeText = noNarrativeText ? "" : narrativeData ? ` in the "${narrativeData.name}" narrative` : " across all narratives";
	let filterSentence = "";

	if (perspective === "Audience") {
		let ages = "";
		let description = "";
		let followers = "";
		let interests = "";
		let subject = "";
		let location = "";

		const accountTypeFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "audienceType";
		});
		const ageFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "audienceAge";
		});
		const followersFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "audienceFollowers";
		});
		const interestsFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "audienceInterest";
		});
		const locationFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "audienceState";
		});
		const politicalFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "audiencePolitics";
		});
		const genderFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "audienceGender";
		});
		// write a different sentence if there are no filters
		if (
			accountTypeFilters.length +
				ageFilters.length +
				followersFilters.length +
				interestsFilters.length +
				locationFilters.length +
				politicalFilters.length +
				genderFilters.length ===
			0
		) {
			filterSentence = " shared by all people.";
		} else {
			if (politicalFilters && politicalFilters.length > 0 && politicalFilters.length < 3) {
				politicalFilters.map((politicalObj, index) => {
					description = index === 0 ? `${description}${politicalObj.name} ` : `${description}and ${politicalObj.name} `;
				});
			}

			if (genderFilters && genderFilters.length > 0 && genderFilters.length < 2) {
				description = `${description}${genderFilters[0].id === "male" ? "Male " : "Female "}`;
			}

			// There must be a subject
			subject =
				!accountTypeFilters || accountTypeFilters.length !== 1
					? "people"
					: accountTypeFilters[0].name === "Person"
					? "Individuals"
					: "Organizations";

			if (ageFilters && ageFilters.length > 0) {
				ages = " ages ";
				ageFilters.length > 1
					? ageFilters.map((ageObj, index) => {
							// last filter
							if (index >= ageFilters.length - 1) {
								ages = `${ages} and ${ageObj.name}`;
							} else if (index === 0) {
								ages = `${ages}${ageObj.name}`;
							} else {
								ages = `${ages}, ${ageObj.name}`;
							}
					  })
					: (ages = `${ages}${ageFilters[0].name}`);
			}

			if (locationFilters && locationFilters.length > 0) {
				location = " from ";
				locationFilters.length > 1
					? locationFilters.map((locationObj, index) => {
							// last filter
							if (index >= locationFilters.length - 1) {
								location = `${location} and ${locationObj.name}`;
							} else if (index === 0) {
								location = `${location}${locationObj.name}`;
							} else {
								location = `${location}, ${locationObj.name}`;
							}
					  })
					: (location = `${location}${locationFilters[0].name}`);
			}

			if (followersFilters && followersFilters.length > 0) {
				followers = " with ";
				followersFilters.length > 1
					? followersFilters.map((followersObj, index) => {
							// last filter
							if (index >= followersFilters.length - 1) {
								followers = `${followers} and ${followersObj.name}`;
							} else if (index === 0) {
								followers = `${followers}${followersObj.name}`;
							} else {
								followers = `${followers}, ${followersObj.name}`;
							}
					  })
					: (followers = `${followers}${followersFilters[0].name}`);
				followers = `${followers} followers`;
			}

			if (interestsFilters && interestsFilters.length > 0) {
				interests = " who are interested in ";
				interestsFilters.length > 1
					? interestsFilters.map((interestsObj, index) => {
							// last filter
							if (index >= interestsFilters.length - 1) {
								interests = `${interests} and ${interestsObj.name}`;
							} else if (index === 0) {
								interests = `${interests}${interestsObj.name}`;
							} else {
								interests = `${interests}, ${interestsObj.name}`;
							}
					  })
					: (interests = `${interests}${interestsFilters[0].name}`);
			}

			// console.log(`shared by ${description}${subject}${ages}${location}.`);

			filterSentence = `${narrativeText} shared by ${description}${subject}${ages}${location}${followers}${interests}.`;
		}
	} else {
		let description = "";
		let location = "";
		let subject = "";
		let reach = "";

		const publicationTypeFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "sourceType";
		});
		const reachFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "sourceReach";
		});
		const locationFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "sourceState";
		});
		const politicalFilters = _.filter(clonedFilters, (filter) => {
			return filter.parent === "sourcePolitics";
		});
		if (publicationTypeFilters.length + reachFilters.length + locationFilters.length + politicalFilters.length === 0) {
			filterSentence = " shared by all outlets.";
		} else {
			if (politicalFilters && politicalFilters.length > 0 && politicalFilters.length < 3) {
				politicalFilters.map((politicalObj, index) => {
					description = index === 0 ? `${description}${politicalObj.name} ` : `${description}and ${politicalObj.name} `;
				});
			}

			if (publicationTypeFilters && publicationTypeFilters.length > 0) {
				publicationTypeFilters.length > 1
					? publicationTypeFilters.map((publicationObj, index) => {
							// last filter
							if (index >= publicationTypeFilters.length - 1) {
								subject = `${subject} and ${publicationObj.name}`;
							} else if (index === 0) {
								subject = `${subject}${publicationObj.name}`;
							} else {
								subject = `${subject}, ${publicationObj.name}`;
							}
					  })
					: (subject = `${subject}${publicationTypeFilters[0].name}`);
			}
			// subject is 'outlets' at a minimum
			subject = `${subject} outlets`;

			if (locationFilters && locationFilters.length > 0) {
				location = " from ";
				locationFilters.length > 1
					? locationFilters.map((locationObj, index) => {
							// last filter
							if (index >= locationFilters.length - 1) {
								location = `${location} and ${locationObj.name}`;
							} else if (index === 0) {
								location = `${location}${locationObj.name}`;
							} else {
								location = `${location}, ${locationObj.name}`;
							}
					  })
					: (location = `${location}${locationFilters[0].name}`);
			}

			if (reachFilters && reachFilters.length > 0) {
				reach = " with a reach of ";
				reachFilters.length > 1
					? reachFilters.map((reachObj, index) => {
							// last filter
							if (index >= reachFilters.length - 1) {
								reach = `${reach} and ${reachObj.name}`;
							} else if (index === 0) {
								reach = `${reach}${reachObj.name}`;
							} else {
								reach = `${reach}, ${reachObj.name}`;
							}
					  })
					: (reach = `${reach}${reachFilters[0].name}`);
				reach = `${reach} readers`;
			}

			// console.log(`published by ${description}${subject}${location}${reach}.`);

			filterSentence = `${narrativeText} published by ${description}${subject}${location}${reach}.`;
		}
	}

	return filterSentence;
};

// returns a string of text describing the filter array passed to it
//		textArray: Array of strings
//		numberAllowed: number - number of filters that will be spelled out.
//			if numberAllowed = 2, then [cat, dog, rat] = cat, + 2 more
export const shortenTextArray = (textArray, numberAllowed) => {
	let text = "";
	const limit = numberAllowed - 1 || 1;
	if (textArray && textArray.length > 0 && textArray.length <= limit + 1) {
		text = textArray.join(", ");
	} else if (textArray && textArray.length > 0) {
		const allowedText = textArray.slice(0, limit);
		text = `${allowedText.join(", ")}, + ${textArray.length - limit} more`;
	}

	return text;
};

// Returns a boolean
export const textTooLong = ({ space, text }) => {
	const textWidth = text.length * 7;
	return textWidth > space;
};

const jargon = [
	"China",
	"US",
	"Trump",
	"wrong",
	"blasts",
	"cost",
	"carbon",
	"unleash",
	"on",
	"who",
	"to",
	"men",
	"women",
	"shame",
	"tweet",
	"Democrats",
	"Republicans",
	"takes",
	"the",
	"final",
	"witch hunt",
	"said",
	"consider",
	"party",
	"global",
	"dollar",
	"spending",
	"Pelosi",
	"initiative",
	"war",
	"business",
	"of",
	"why",
	"fear",
	"from",
	"is",
	"it",
	"safe",
	"false",
	"truth",
	"media",
];

const lorem = [
	"Lorem",
	"ipsum",
	"dolor",
	"sit",
	"amet",
	"consectetur",
	"adipiscing",
	"elit",
	"sed",
	"do",
	"eiusmod",
	"tempor",
	"incididunt",
	"ut",
	"labore",
	"et",
	"dolore",
	"magna",
	"aliqua",
	"Ut",
	"enim",
	"ad",
	"minim",
	"veniam",
	"quis",
	"nostrud",
	"exercitation",
	"ullamco",
	"laboris",
	"nisi",
	"ut",
	"aliquip",
	"ex",
	"ea",
	"commodo",
	"consequa",
];
const capitalize = (word) => {
	return word.charAt(0).toUpperCase() + word.slice(1);
};

// Create a random jumble of a title, 5-20 words long
export const unintelligibleTitle = (length) => {
	let title = "";

	const numberOfWords = length || _.random(5, 20);

	_.times(numberOfWords, (index) => {
		const word = lorem[_.random(0, lorem.length - 1)];

		title = index === 0 ? capitalize(word) : `${title} ${word}`;
	});

	return title;
};
